export const icons = [
    'add',
    'as',
    'back',
    'bell',
    'calendar',
    'circle',
    'content-copy',
    'contract',
    'cube-block',
    'cupon',
    'document',
    'dot_grid',
    'download',
    'edit',
    'edit-pencil',
    'euro',
    'form',
    'details',
    'steps',
    'filter',
    'five_lines',
    'folder_client',
    'folders',
    'four_lines',
    'home',
    'link',
    'logout',
    'monitoring',
    'offices',
    'processors',
    'reiterations',
    'remove',
    'report',
    'search',
    'time',
    'settings',
    'suitcase',
    'three_lines',
    'upload',
    'warning',
    'notices',
    'cancel',
    'check_circle',
    'summarize',
    'add_circle',
];
